export const mrpFr = {
  title: 'Planification des besoins matières',
  subtitle:
    'Besoins, réceptions et propositions non contraignantes échelonnés dans le temps avec instantané reproductible.',
  help: { open: 'Ouvrir l’aide de planification des besoins' },
  tabs: {
    planning: 'Planification',
    history: 'Historique des calculs',
    policies: 'Paramètres de planification',
  },
  run: {
    title: 'Créer un calcul MRP',
    description:
      'Choisissez la date, l’horizon et éventuellement les articles. Le calcul ne crée jamais automatiquement de commande.',
  },
  fields: {
    asOf: 'Date de planification',
    horizon: 'Fin de l’horizon',
    productScope: 'Périmètre articles',
    strategy: 'Stratégie d’approvisionnement',
    safetyStock: 'Stock de sécurité',
    procurementLead: 'Délai d’achat (jours)',
    productionLead: 'Délai de production (jours)',
    productionMinimum: 'Quantité minimale de production',
    productionLot: 'Taille de lot de production',
    note: 'Motif / note',
  },
  allProducts: 'Tous les articles gérés en stock',
  actions: {
    run: 'Exécuter le MRP',
    'convert-purchase': 'Créer un brouillon d’achat',
    'convert-production': 'Créer un brouillon de production',
    dismiss: 'Écarter la proposition',
  },
  messages: {
    invalidInput: 'Vérifiez les données de planification.',
    runCreated: 'L’instantané MRP immuable a été créé.',
    policySaved: 'Paramètres enregistrés.',
    'convert-purchase': 'Le brouillon d’achat a été créé explicitement.',
    'convert-production': 'Le brouillon de production a été créé explicitement.',
    dismiss: 'Proposition écartée avec motif.',
  },
  stats: {
    products: 'Articles',
    shortages: 'Ruptures',
    purchase: 'Propositions d’achat',
    production: 'Propositions de production',
    manual: 'Contrôle manuel',
    warnings: 'Alertes',
  },
  columns: {
    product: 'Article',
    gross: 'Besoin brut',
    available: 'Stock disponible',
    reserved: 'Réservé',
    receipts: 'Réceptions attendues',
    net: 'Besoin net',
    due: 'Date du besoin',
    action: 'Proposition d’action',
    date: 'Date',
    event: 'Événement',
    quantity: 'Quantité',
    formula: 'Calcul',
    run: 'Calcul',
    created: 'Créé',
  },
  empty: {
    noRunTitle: 'Aucun résultat sélectionné',
    noRun: 'Créez un calcul ou choisissez un résultat immuable dans l’historique.',
  },
  snapshot: 'Empreinte source {{sourceHash}} · résultat {{resultHash}}',
  details: {
    timeline: 'Trace du calcul',
    timelineDescription:
      'Le même jour, les réceptions précèdent les besoins ; chaque réception proposée rétablit le stock cible.',
    sources: 'Sources des besoins et réceptions',
    sourcesDescription:
      'Chaque quantité renvoie au document, à l’ordre de production ou au stock figé utilisé.',
  },
  events: {
    OPENING: 'Stock initial',
    DEMAND: 'Besoin',
    SUPPLY: 'Réception',
    PLANNED_RECEIPT: 'Réception proposée',
  },
  sourceTypes: {
    SALES_ORDER: 'Commande client',
    PRODUCTION_MATERIAL: 'Matière de production planifiée',
    PLANNED_PRODUCTION_EXPLOSION: 'Besoin issu de la recette',
    STOCK: 'Stock éligible figé',
    PURCHASE_ORDER: 'Commande fournisseur ouverte',
    PRODUCTION_ORDER: 'Réception de production planifiée',
  },
  suggestion: { none: 'Aucune rupture' },
  statuses: { OPEN: 'Ouverte', CONVERTED: 'Convertie', DISMISSED: 'Écartée' },
  strategies: {
    AUTO: 'Règle automatique',
    BUY: 'Acheter',
    MAKE: 'Produire',
    BUY_OR_MAKE: 'Acheter ou produire',
    NONE: 'Contrôle manuel uniquement',
  },
  policy: {
    title: 'Paramètres de planification par article',
    description:
      'Les seuils restent dans la fiche article ; la stratégie, les délais et lots sont ajoutés ici.',
    dialogTitle: 'Modifier les paramètres',
    dialogDescription: 'Le contrôle de version empêche les écrasements simultanés.',
  },
  decision: {
    'convert-purchase': {
      title: 'Créer le brouillon d’achat ?',
      description:
        'Cette action explicite crée un seul brouillon depuis la proposition figée, sans envoi ni confirmation.',
      confirm: 'Je confirme la création du brouillon d’achat.',
    },
    'convert-production': {
      title: 'Créer le brouillon de production ?',
      description:
        'Cette action explicite utilise la recette et la gamme approuvées figées dans la proposition.',
      confirm: 'Je confirme la création du brouillon de production.',
    },
    dismiss: {
      title: 'Écarter la proposition ?',
      description: 'La rupture reste visible dans le calcul immuable et le motif est audité.',
      confirm: 'Je confirme l’abandon de cette proposition.',
    },
  },
  warningTitle: 'Alerte de planification',
  warnings: {
    MRP_BATCH_STOCK_RECONCILIATION: 'Le total des lots éligibles diffère du stock article.',
    MRP_BATCH_SHELF_LIFE_MISSING: 'Au moins un lot sans durée de vie requise a été exclu.',
    MRP_INCOMPATIBLE_UNIT: 'Une quantité avec unité incompatible a été exclue.',
    MRP_SUPPLIER_MISSING: 'Aucun fournisseur actif approuvé.',
    MRP_APPROVED_RECIPE_OR_ROUTING_MISSING: 'Aucune recette et gamme approuvées correspondantes.',
    MRP_PROCUREMENT_DISABLED: 'L’approvisionnement automatique est désactivé.',
    MRP_RELEASE_DATE_OVERDUE:
      'La date de lancement calculée précède la date de planification ; contrôle immédiat requis.',
  },
} as const;
